<template>
  <div>
    <main class="text-gray-700">
      <router-view />
    </main>
  </div>
</template>
